import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, Redirect } from "react-router-dom";
import NotFound from "../../Utility/Pages/NotFound";
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const SettingsRouteAgent = lazy(() => import('../Modules/Home/Components/Agent/Components/SettingsForAgent/Routes/SettingsRouteAgent'));
const DashboardRoute = lazy(() => import('../Modules/Dashboard/Routes/DashboardRoute'));
const ModifyDashboardRoute = lazy(() => import('../Modules/ModifyDashboardView/Routes/ModifyDashboardRoute'));
const HomeRoute = lazy(() => import('../Modules/Home/Routes/HomeRoute'));
const AgentRoute = lazy(() => import('../Modules/Home/Components/Agent/Routes/AgentRoute'));
const SettingsRoute = lazy(() => import('../Modules/Settings/Routes/SettingsRoute'));
const ReportsRoute = lazy(() => import('../Modules/Reports/Routes/ReportsRoute'));
const HousekeepingRoute = lazy(() => import('../Modules/Housekeeping/Routes/HousekeepingRoute'));
const AccountRoute = lazy(() => import('../Modules/Accounts/Routes/AccountRoute'));
import RevenueManagerRoute from '../Modules/RevenueManager/Routes/RevenueManagerRoute';
import AnotherLoginUrl from '../../GlobalModules/Login/Pages/AnotherLoginUrl';
import LoginActivityRoute from '../Modules/LoginActivity/Routes/LoginActivitiesRoute';
import MobileOnlyRestriction from '../../GlobalModules/Login/Pages/MobileOnlyRestriction';

LoadingOverlay.propTypes = undefined;
class index extends Component {
  componentDidMount() {
    if (this.props.token && this.props.token != "") {
      if (this.props.history.location.pathname.split('/')[2] == "login") {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
      }
    }
  }
  render() {
    return (
      <>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/:lng/auto_login" component={AnotherLoginUrl} />
            <Route exact path="/" component={DashboardRoute} />
            {/* <Route exact path="/:lng/dashboard" component={DashboardRoute} /> */}
            <Route exact path="/:lng/dashboard" render={(props) => {
              return <ModifyDashboardRoute {...props} />;
            }} />
            <Route exact path="/:lng/home/:type?/:branchId?" component={HomeRoute} />
            <Route exact path="/:lng/booking_confirmation/:bookingID?" component={HomeRoute} />
            <Route exact path="/:lng/quick-branch-onboarding" component={HomeRoute} />
            <Route exact path="/:lng/payment" component={HomeRoute} />
            <Route exact path="/:lng/reports/:tab?/:subTab?" component={ReportsRoute} />
            <Route exact path="/:lng/settings/:type?/:next_step?" component={SettingsRoute} />
            {/* <Route exact path="/:lng/agent_dashboard" component={AgentRoute} /> */}
            <Route exact path="/:lng/agent/:type?/:branchId?" component={AgentRoute} />
            <Route exact path="/:lng/agent_settings/:type?/:next_step?" component={SettingsRouteAgent} />
            <Route exact path="/:lng/agent/agent_booking" component={AgentRoute} />
            <Route exact path="/:lng/revenue-manager" component={RevenueManagerRoute} />
            <Route exact path="/:lng/housekeeping/:type?/:branchId?" component={HousekeepingRoute} />
            <Route exact path="/:lng/login-activities" component={LoginActivityRoute} />
            <Route exact path="/:lng/mobile-only-restriction" component={MobileOnlyRestriction} />
            <Route exact path="/:lng/accounts/:type?/:branchId?" component={AccountRoute} />
          </Switch >
        </Suspense >
      </>


    );
  }
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    accessToken: globalState.LoginReducer.accessToken,
    token: globalState.LoginReducer.token,
    leftbar: globalState.mainReducerData.leftbar,
  };
}

export default connect(mapStateToProps)(withRouter(index));

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
